module.exports = __webpack_public_path__ + "static/media/193.ac2b2bc6.png";